var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Breadcrumbs } from "@/components/common/Breadcrumbs";
import { EvaluateServiceButton } from "@/components/common/EvaluateServiceButton";
import { Container } from "@/components/common/Container";
import { PageTitle } from "@/components/common/PageTitle";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/Alert";
import { Button } from "@/components/ui/Button";
import { Form, FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage, } from "@/components/ui/Form";
import { Input } from "@/components/ui/Input";
import { InputMask } from "@/components/ui/InputMask";
import { LoadingSpinner } from "@/components/ui/LoadingSpinner";
import { SelectContent, SelectItem, SelectTrigger, SelectValue, } from "@/components/ui/Select";
import { useStepperControl } from "@/hooks/useStepperControl";
import { cn } from "@/lib/utils";
import { ResponseModel } from "@/models/ResponseModel";
import { listaUf } from "@/models/uf";
import GatewayService from "@/services/api/GatewayService";
import { zodResolver } from "@hookform/resolvers/zod";
import { Share2Icon } from "@radix-ui/react-icons";
import { Select } from "@radix-ui/react-select";
import { isAxiosError } from "axios";
import { AlertTriangle } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { DialogSuccess } from "./success";
import toast from "react-hot-toast";
var BREADCRUMB_ITEMS = [
    {
        name: "Página Inicial",
        path: "https://portal.pi.gov.br/detran/",
    },
    {
        name: "Verificar Veículo",
        path: "/",
    },
    {
        name: "Alterar Endereço do Veículo",
        path: "/",
        current: true,
    },
];
export function AlterarEndereco() {
    var _this = this;
    var service = new GatewayService();
    var _a = useState(), setCepConsultado = _a[1];
    var _b = useState([]), municipios = _b[0], setMunicipios = _b[1];
    var _c = useState(false), isLoading = _c[0], setIsLoading = _c[1];
    var _d = useState(""), error = _d[0], setError = _d[1];
    var _e = useState(false), success = _e[0], setSuccess = _e[1];
    var _f = useState(""), successMessage = _f[0], setSuccessMessage = _f[1];
    var _g = useState(false), isVerified = _g[0], setIsVerified = _g[1];
    var recaptchaRef = useRef(null);
    var formSchema = z.object({
        placa: z.string().optional(),
        renavam: z.string().min(11).max(11).optional(),
        crv: z.string().min(12).max(12),
        endereco: z
            .string()
            .min(1, "Endereço inválido")
            .max(30, "Endereço inválido"),
        numeroEndereco: z
            .string()
            .min(1, "Número inválido")
            .max(10, "Número inválido"),
        complemento: z
            .string()
            .max(50, "Tamanho máximo de 50 caracteres")
            .optional(),
        bairro: z.string().min(1, "Bairro inválido").max(30, "Bairro inválido"),
        uf: z.string().min(2, "UF inválida").max(2, "UF inválida"),
        municipio: z
            .string()
            .min(1, "Município inválido")
            .max(4, "Município inválido"),
        cep: z
            .string()
            .min(9, "CEP inválido")
            .max(9, "CEP inválido")
            .refine(function (value) {
            return value.length === 9 && value.startsWith("64");
        }, "CEP inválido"),
        comprovanteBase64: z.string().refine(function (value) {
            return value.length > 0;
        }, "Comprovante de endereço inválido"),
        comprovanteBase64Fake: z.string().refine(function (value) {
            console.log(value);
            return !!value;
        }, "Informe o comprovante de endereço"),
    });
    var _h = useStepperControl(), setServiceReturn = _h.setServiceReturn, moveThroughStep = _h.moveThroughStep, serviceReturn = _h.serviceReturn;
    var form = useForm({
        resolver: zodResolver(formSchema),
        defaultValues: {
            placa: (serviceReturn === null || serviceReturn === void 0 ? void 0 : serviceReturn.placa) || "",
            renavam: (serviceReturn === null || serviceReturn === void 0 ? void 0 : serviceReturn.renavam) || "",
            crv: (serviceReturn === null || serviceReturn === void 0 ? void 0 : serviceReturn.crv) || "",
            bairro: "",
            cep: "",
            complemento: "",
            endereco: "",
            municipio: (serviceReturn === null || serviceReturn === void 0 ? void 0 : serviceReturn.municipio) || "",
            numeroEndereco: "",
            uf: (serviceReturn === null || serviceReturn === void 0 ? void 0 : serviceReturn.uf) || "",
            comprovanteBase64: "",
            comprovanteBase64Fake: "",
        },
    });
    var cepChanged = form.watch("cep");
    var ufChanged = form.watch("uf");
    var onCloseSucess = function () {
        setServiceReturn({});
        moveThroughStep(0);
    };
    var onSubmit = function (values) { return __awaiter(_this, void 0, void 0, function () {
        var data, ret, e_1;
        var _a, _b, _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    if (!((_a = recaptchaRef.current) === null || _a === void 0 ? void 0 : _a.getValue())) {
                        toast.error("Por favor, confirme o captcha para continuar");
                        return [2 /*return*/];
                    }
                    setError("");
                    _f.label = 1;
                case 1:
                    _f.trys.push([1, 3, 4, 5]);
                    data = {
                        placa: (serviceReturn === null || serviceReturn === void 0 ? void 0 : serviceReturn.placa.replace(/[^0-9A-Za-z]/g, "").toUpperCase()) || "",
                        renavam: (serviceReturn === null || serviceReturn === void 0 ? void 0 : serviceReturn.renavam) || "",
                        tipoDocProprietario: (serviceReturn === null || serviceReturn === void 0 ? void 0 : serviceReturn.tipoDocProprietario) || "",
                        numDocProprietario: (serviceReturn === null || serviceReturn === void 0 ? void 0 : serviceReturn.numDocProprietario) || "",
                        endereco: {
                            logradouro: values.endereco,
                            numero: values.numeroEndereco,
                            complemento: values.complemento,
                            bairro: values.bairro,
                            codigoMunicipio: Number(values.municipio),
                            uf: values.uf,
                            cep: values.cep.replace(/[^0-9]/g, ""),
                        },
                        comprovanteBase64: values.comprovanteBase64,
                    };
                    setIsLoading(true);
                    return [4 /*yield*/, service.alterarEndereco(data, (_b = recaptchaRef.current) === null || _b === void 0 ? void 0 : _b.getValue())];
                case 2:
                    ret = _f.sent();
                    if (ResponseModel.isOk(ret)) {
                        setSuccess(true);
                        setSuccessMessage("Endereço alterado com sucesso");
                    }
                    return [3 /*break*/, 5];
                case 3:
                    e_1 = _f.sent();
                    if (isAxiosError(e_1)) {
                        setError(((_d = (_c = e_1 === null || e_1 === void 0 ? void 0 : e_1.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.message) || "Erro desconhecido");
                    }
                    else {
                        setError(((_e = e_1 === null || e_1 === void 0 ? void 0 : e_1.data) === null || _e === void 0 ? void 0 : _e.message) || (e_1 === null || e_1 === void 0 ? void 0 : e_1.message) || "Erro desconhecido");
                    }
                    return [3 /*break*/, 5];
                case 4:
                    handleResetRecaptcha();
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    function onError(values) {
        console.log("error", values);
        // handleNextStep();
    }
    useEffect(function () {
        if (cepChanged) {
            if (cepChanged.replace(/[^0-9]/g, "").length === 8 &&
                cepChanged.startsWith("64")) {
                setIsLoading(true);
                var cep = service
                    .consultarCep(cepChanged)
                    .then(function (r) {
                    var _a, _b, _c;
                    if (ResponseModel.isOk(r)) {
                        setCepConsultado(r.data);
                        form.setValue("endereco", (_a = r.data.logradouro) !== null && _a !== void 0 ? _a : "");
                        form.setValue("bairro", (_b = r.data.bairro) !== null && _b !== void 0 ? _b : "");
                        form.setValue("complemento", (_c = r.data.complemento) !== null && _c !== void 0 ? _c : "");
                    }
                })
                    .finally(function () {
                    setIsLoading(false);
                });
            }
        }
    }, [cepChanged, form.setValue]);
    useEffect(function () {
        if (ufChanged) {
            if (ufChanged.length === 2) {
                setIsLoading(true);
                var cidades = service
                    .consultarMunicipio(ufChanged)
                    .then(function (r) {
                    if (ResponseModel.isOk(r)) {
                        setMunicipios(r.list);
                    }
                })
                    .finally(function () {
                    setIsLoading(false);
                });
            }
        }
    }, [ufChanged]);
    var goExternalService = function (event) {
        var baseUrl = process.env.PORTAL_URL || "https://dev.pidigital.pi.gov.br";
        var url = baseUrl + "/app/app-altera-endereco-veiculo";
        var newWindow = window.open(url, "_blank");
        newWindow === null || newWindow === void 0 ? void 0 : newWindow.focus();
        event === null || event === void 0 ? void 0 : event.preventDefault();
        return false;
    };
    function handleVerifyChange() {
        var _a, _b;
        if (!!((_a = recaptchaRef.current) === null || _a === void 0 ? void 0 : _a.getValue()) !== isVerified) {
            setIsVerified(!!((_b = recaptchaRef.current) === null || _b === void 0 ? void 0 : _b.getValue()));
        }
    }
    function handleResetRecaptcha() {
        var _a;
        (_a = recaptchaRef.current) === null || _a === void 0 ? void 0 : _a.reset();
        setIsVerified(false);
    }
    var isLoadingApp = isLoading;
    var isDisabled = isLoadingApp || !isVerified;
    return (_jsxs(Container, { children: [_jsx(Breadcrumbs, { pages: BREADCRUMB_ITEMS }), _jsx(PageTitle, { title: "Alterar Endere\u00E7o do Ve\u00EDculo" }), _jsx(Form, __assign({}, form, { children: _jsxs("form", __assign({ onSubmit: form.handleSubmit(onSubmit, onError), className: "w-full max-w-[856px] space-y-4 animate-fade-left" }, { children: [_jsxs("div", __assign({ className: "container p-4 flex flex-wrap rounded-md border-2" }, { children: [_jsx("div", __assign({ className: "w-full text-pretty font-semibold text-[1.1rem] text-gray-600" }, { children: "Ve\u00EDculo" })), _jsx(FormField, { control: form.control, disabled: true, name: "placa", render: function (_a) {
                                        var field = _a.field;
                                        return (_jsxs(FormItem, __assign({ className: "w-full pr-0 md:pr-1 md:w-1/3 relative" }, { children: [_jsx(FormLabel, __assign({ className: "text-gray-400" }, { children: "Placa" })), _jsx(FormControl, { children: _jsx(InputMask, __assign({ className: "uppercase", placeholder: "", mask: "aaa-9*99" }, field)) }), _jsx(FormDescription, { children: "Informe o n\u00BA da placa do ve\u00EDculo." }), _jsx(FormMessage, {})] })));
                                    } }), _jsx(FormField, { control: form.control, disabled: true, name: "renavam", render: function (_a) {
                                        var field = _a.field;
                                        return (_jsxs(FormItem, __assign({ className: "w-full pl-0 md:pl-1 md:w-1/3 relative" }, { children: [_jsx(FormLabel, __assign({ className: "text-gray-400" }, { children: "Renavam" })), _jsx(FormControl, { children: _jsx(Input, __assign({ placeholder: "000000000", maxLength: 11 }, field)) }), _jsx(FormDescription, { children: "Informe o n\u00BA do RENAVAM." }), _jsx(FormMessage, {})] })));
                                    } }), _jsx(FormField, { control: form.control, disabled: true, name: "crv", render: function (_a) {
                                        var field = _a.field;
                                        return (_jsxs(FormItem, __assign({ className: "w-full pl-0 md:pl-1 md:w-1/3 relative" }, { children: [_jsx(FormLabel, __assign({ className: "text-gray-400" }, { children: "N\u00FAmero do CRV" })), _jsx(FormControl, { children: _jsx(Input, __assign({ placeholder: "N\u00FAmero do CRV", maxLength: 12 }, field)) }), _jsx(FormDescription, { children: "Informe o n\u00BA do CRV." }), _jsx(FormMessage, {})] })));
                                    } })] })), _jsxs("div", __assign({ className: "container mt-2 p-4 flex flex-wrap rounded-md border-2" }, { children: [_jsx("div", __assign({ className: "w-full text-pretty font-semibold text-[1.1rem] text-gray-600" }, { children: "Endere\u00E7o" })), _jsx(FormField, { control: form.control, name: "cep", render: function (_a) {
                                        var field = _a.field;
                                        return (_jsxs(FormItem, __assign({ className: "w-full pl-0 md:pl-1 md:w-1/4 relative" }, { children: [_jsx(FormLabel, { children: "CEP" }), _jsx(FormControl, { children: _jsx(InputMask, __assign({ placeholder: "CEP", mask: "99999-999" }, field)) }), _jsx(FormDescription, { children: "Informe o CEP." }), _jsx(FormMessage, {})] })));
                                    } }), _jsx(FormField, { control: form.control, name: "endereco", render: function (_a) {
                                        var field = _a.field;
                                        return (_jsxs(FormItem, __assign({ className: "w-full pl-0 md:pl-1 md:w-2/4 relative" }, { children: [_jsx(FormLabel, { children: "Endere\u00E7o " }), _jsx(FormControl, { children: _jsx(Input, __assign({ placeholder: "Endere\u00E7o", maxLength: 30 }, field)) }), _jsx(FormDescription, { children: "Informe o endere\u00E7o." }), _jsx(FormMessage, {})] })));
                                    } }), _jsx(FormField, { control: form.control, name: "numeroEndereco", render: function (_a) {
                                        var field = _a.field;
                                        return (_jsxs(FormItem, __assign({ className: "w-full pl-0 md:pl-1 md:w-1/4 relative" }, { children: [_jsx(FormLabel, { children: "N\u00FAmero" }), _jsx(FormControl, { children: _jsx(Input, __assign({ placeholder: "N\u00FAmero", maxLength: 10 }, field)) }), _jsx(FormDescription, { children: "Informe o n\u00FAmero do endere\u00E7o." }), _jsx(FormMessage, {})] })));
                                    } }), _jsx(FormField, { control: form.control, name: "bairro", render: function (_a) {
                                        var field = _a.field;
                                        return (_jsxs(FormItem, __assign({ className: "w-full pl-0 md:pl-1 md:w-1/2 relative" }, { children: [_jsx(FormLabel, { children: "Bairro" }), _jsx(FormControl, { children: _jsx(Input, __assign({ placeholder: "Bairro", maxLength: 20 }, field)) }), _jsx(FormDescription, { children: "Informe o bairro do endere\u00E7o." }), _jsx(FormMessage, {})] })));
                                    } }), _jsx(FormField, { control: form.control, name: "complemento", render: function (_a) {
                                        var field = _a.field;
                                        return (_jsxs(FormItem, __assign({ className: "w-full pl-0 md:pl-1 md:w-1/2 relative" }, { children: [_jsx(FormLabel, { children: "Complemento" }), _jsx(FormControl, { children: _jsx(Input, __assign({ placeholder: "Complemento", maxLength: 50 }, field)) }), _jsx(FormDescription, { children: "Informe o complemento do endere\u00E7o." }), _jsx(FormMessage, {})] })));
                                    } }), _jsx(FormField, { control: form.control, disabled: true, name: "uf", render: function (_a) {
                                        var field = _a.field;
                                        return (_jsxs(FormItem, __assign({ className: "w-full pl-0 md:pl-1 md:w-1/4 relative" }, { children: [_jsx(FormLabel, { children: "UF" }), _jsx(FormControl, { children: _jsxs(Select, __assign({ onValueChange: field.onChange, defaultValue: field.value }, field, { children: [_jsx(SelectTrigger, __assign({ disabled: isLoadingApp }, { children: _jsx(SelectValue, { placeholder: "Selecione a UF" }) })), _jsx(SelectContent, { children: listaUf.map(function (uf) { return (_jsx(SelectItem, __assign({ value: "".concat(uf.sigla) }, { children: "".concat(uf.sigla) }))); }) })] })) }), _jsx(FormDescription, { children: "Informe a UF do endere\u00E7o." }), _jsx(FormMessage, {})] })));
                                    } }), _jsx(FormField, { control: form.control, disabled: true, name: "municipio", render: function (_a) {
                                        var field = _a.field;
                                        return (_jsxs(FormItem, __assign({ className: "w-full pl-0 md:pl-1 md:w-1/4 relative" }, { children: [_jsx(FormLabel, { children: "Cidade" }), _jsx(FormControl, { children: _jsxs(Select, __assign({ onValueChange: field.onChange, defaultValue: field.value }, field, { children: [_jsx(SelectTrigger, __assign({ disabled: isLoadingApp }, { children: _jsx(SelectValue, { placeholder: "Selecione a Cidade" }) })), _jsx(SelectContent, { children: municipios.map(function (mun) { return (_jsx(SelectItem, __assign({ value: "".concat(mun.codigo) }, { children: "".concat(mun.descricao) }))); }) })] })) }), _jsx(FormDescription, { children: "Informe a cidade do endere\u00E7o." }), _jsx(FormMessage, {})] })));
                                    } }), _jsx(FormField, { control: form.control, name: "comprovanteBase64Fake", render: function (_a) {
                                        var field = _a.field;
                                        return (_jsxs(FormItem, __assign({ className: "w-full pl-0 md:pl-1 md:w-1/2 relative" }, { children: [_jsx(FormLabel, { children: "Comprovante de Endere\u00E7o" }), _jsx(FormControl, { children: _jsx(Input, __assign({ type: "file", accept: "application/pdf", placeholder: "Comprovante de Endere\u00E7o", maxLength: 20 }, field, { onChange: function (e) {
                                                            var _a;
                                                            var oldChange = field.onChange;
                                                            var file = (_a = e.target.files) === null || _a === void 0 ? void 0 : _a[0];
                                                            if (file && file.type === "application/pdf") {
                                                                var reader_1 = new FileReader();
                                                                reader_1.onloadend = function () {
                                                                    var comprovante = reader_1.result;
                                                                    var base64 = comprovante.split(",")[1];
                                                                    form.setValue("comprovanteBase64", base64);
                                                                };
                                                                reader_1.readAsDataURL(file);
                                                                oldChange(e);
                                                            }
                                                            else {
                                                                setError("Arquivo inválido");
                                                                form.setValue("comprovanteBase64", "");
                                                                oldChange("");
                                                            }
                                                        } })) }), _jsx(FormDescription, { children: "Informe o comprovante de endere\u00E7o." }), _jsx(FormMessage, {})] })));
                                    } })] })), _jsx("div", __assign({ className: "flex gap-4 items-center justify-center" }, { children: _jsx("div", __assign({ className: "w-full" }, { children: _jsx(ReCAPTCHA, { ref: recaptchaRef, sitekey: "6LfhvnksAAAAAKei6tW4nUvdqkKz9cU0cQnE_VQD", onChange: handleVerifyChange }) })) })), _jsxs("div", __assign({ className: "container px-0 flex flex-wrap space-y-4 animate-fade-left md:space-y-0" }, { children: [_jsx("div", __assign({ className: "w-full pr-0 md:pr-6 md:w-1/2 relative" }, { children: _jsxs(Button, __assign({ onClick: goExternalService, className: "self-end w-full bg-etipi-green" }, { children: [_jsx("div", __assign({ className: "rotate-45" }, { children: _jsx(Share2Icon, {}) })), "Acessar servi\u00E7o no Gov.pi Cidad\u00E3o"] })) })), _jsx("div", __assign({ className: cn("w-full pl-0 md:pl-6 md:w-1/2 relative", isLoadingApp && "cursor-progress"
                                    // errorLocaisRecebimento && "cursor-not-allowed"
                                    ) }, { children: _jsx(Button, __assign({ type: "submit", className: "self-end w-full bg-etipi-blue", disabled: isDisabled }, { children: isLoadingApp ? _jsx(LoadingSpinner, {}) : "Avançar" })) }))] }))] })) })), _jsx(DialogSuccess, { onClose: onCloseSucess, message: successMessage, showDialog: success, setShowDialog: setSuccess }), error && (_jsxs(Alert, __assign({ variant: "destructive", className: "w-full max-w-[856px] bg-red-100 border-0" }, { children: [_jsx(AlertTriangle, { className: "h-4 w-4" }), _jsx(AlertTitle, { children: "Aten\u00E7\u00E3o!" }), _jsx(AlertDescription, { children: error })] }))), _jsx(EvaluateServiceButton, {})] }));
}
